import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';

interface PictureSortDropdownAttrs {
    sort: string
    onchange: (sort: string) => void
}

export default class PictureSortDropdown implements ClassComponent<PictureSortDropdownAttrs> {
    view(vnode: Vnode<PictureSortDropdownAttrs>) {
        const sortOptions: { [key: string]: string } = {};

        ['latest', 'oldest', 'latestTake', 'oldestTake'].forEach(key => {
            sortOptions[key] = app.translator.trans('kilowhat-cimaise.forum.picture-sort.' + key) + '';
        });

        return Dropdown.component({
            buttonClassName: 'Button',
            label: sortOptions[vnode.attrs.sort] || Object.keys(sortOptions).map(key => sortOptions[key])[0],
        }, Object.keys(sortOptions).map(value => {
            const label = sortOptions[value];
            const active = (vnode.attrs.sort || Object.keys(sortOptions)[0]) === value;

            return Button.component({
                icon: active ? 'fas fa-check' : true,
                onclick: () => {
                    vnode.attrs.onchange(value);
                },
                active,
            }, label);
        }));
    }
}
